<template>
  <div class="container-fluid promotion-page p-2 pt-3">
    <div class="promotion-page__inner">
      <div class="col-12 px-1 mb-5 pb-5">
        <div
          class="card bg-transparent mt-2 promotion-card"
          v-for="(promotion, proIndex) in promotions"
          :key="proIndex"
        >
          <a href="#">
            <img
              class="promotion-card__image"
              :src="promotion.image"
              :alt="promotion.title"
            >
          </a>
          <div class="px-3 py-2 d-flex justify-content-between bg-transparent">
            <h3 class="text-dark my-auto">
              {{ promotion.title }}
            </h3>
            <button
              class="detail-button col-3"
              @click="openPromotion(proIndex)"
            >
              {{ $t('detail') }}
            </button>
          </div>

          <van-overlay
            :show="selectedPromotion === proIndex"
            @click="selectedPromotion = null"
          >
            <div class="wrapper col-12 d-flex h-100vh">
              <div class="col-11 card mx-auto my-auto py-4 px-3 promotion-overlay__card">
                <h2 class="pb-3 promotion-overlay__title">
                  {{ promotion.title }}
                </h2>
                <span
                  class="promotion-overlay__description"
                  v-html="formatDescription(promotion.description)"
                ></span>
              </div>
            </div>
          </van-overlay>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import promo1 from '@/assets/promo1.png';

export default {
  data() {
    return {
      selectedPromotion: null,
      promotions: [
        {
          title: 'မန်ဘာသစ် (100% ဘောနပ်စ်)',
          description: `📌 5,000 သွင်း 5,000 အပိုရ
10,000သွင်း 10,000 အပိုရ 
(ဘောနပ်အများဆုံး 30,000 ယူနစ်)

💢စည်းကမ်းချက် 💢
💢သွင်းငွေနဲ့ ဘောနပ်ပေါင်းပြီး 5ဆ ပြည့်အောင်ကစားပေးရပါမယ်ရှင့် 
💢အနိုင်ငွေကို သွင်းငွေရဲ့ 3 ဆသာထုပ်ပေးမှာပါရှင့် (ကျန်ယူနစ်များကိုဆာဗာကနုတ်ယူသွားမာဖစ်ပါတယ်)`,
          image: 'https://storage.googleapis.com/spacetech2/thingaha/promo1.avif',
        },
        {
          title: 'နေ့စဉ်ဘောနပ် 10%',
          description: `💢တစ်ရက်ကို ဘောနပ် (3) ကြိမ်ရယူနိုင်သည်။
💢 ဘောနပ် အများဆုံး 30,000
💢ဆနဲ့ကစားစရာမလို အနိုင်ငွေ 8,000 ပြည့်တာနဲ့  ငွေအကန့်အသတ်မရှိထုပ်ယူလိုရပါမည်။`,
          image: promo1,
        },
        {
          title: 'ရှူံးကြေး 5%',
          description: `💢တစ်ရက်တာသွင်းငွေ 30000 ကျပ် ရှုးတာနဲ့ ရှုးကြေး (5%) ပြန်ပေးပါတယ်ရှင့်
💢အများဆုံးဘောနပ် 30000 
💢ဘောနပ်ရဲ့  5ဆပြည့်အောင်ကစားပြီး အနိုင်ငွေကို ဘောနပ်ရဲ့ 2ဆသာထုပ်ယူလိုရပါမယ်ရှင့်
💢ကျန်ယူနစ်များကိုဆာဗာကနုတ်ယူသွားမာဖစ်ပါတယ်ရှင့်`,
          image: 'https://storage.googleapis.com/spacetech2/thingaha/promo3.avif',
        },
      ],
    };
  },
  methods: {
    openPromotion(index) {
      this.selectedPromotion = index;
    },
    formatDescription(text) {
      return (text || '').replace(/\n/g, '<br>');
    },
  },
};
</script>

<style scoped>
.promotion-page {
  height: 100vh;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  background:
    radial-gradient(ellipse 100% 50% at 50% 0%, rgba(250, 97, 11, 0.22) 0%, transparent 50%),
    linear-gradient(180deg, #1A1428 0%, #16122A 22%, #12101C 55%, #0D0B14 100%);
  background-size: cover;
  background-attachment: fixed;
  padding-bottom: 15rem;
}

.promotion-page .text-dark {
  color: #F4F0E8 !important;
}

.promotion-page__inner {
  height: 130vh;
}

.promotion-card {
  box-shadow: none;
}

.promotion-card__image {
  border-radius: 5px;
  width: 100%;
}

.promotion-overlay__card {
  background: #12101C !important;
  border: 1px solid rgba(245, 197, 24, 0.35);
}

.promotion-overlay__title {
  color: #E8C547;
}

.promotion-overlay__description {
  color: #d4d0d0;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 1px solid #E76229;
  text-transform: uppercase;
  border-radius: 14px;
  box-sizing: border-box;
  color: #E8C547;
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 1px 5px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: #fff;
  background: linear-gradient(135deg, #FA610B 0%, #F88D14 100%);
  border-color: #E8C547;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
  background: linear-gradient(135deg, #FA610B 0%, #F88D14 100%);
  border-color: #1A1428;
}
</style>
